module.exports = __webpack_public_path__ + "img/175.c9f8f98d.jpg";